import _extends from "@babel/runtime/helpers/extends";
import Button from '@atlaskit/button/loading-button';
import { Checkbox } from '@atlaskit/checkbox';
import Form, { CheckboxField, FormFooter, FormSection } from '@atlaskit/form';
import { ButtonClickedEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import React from 'react';
import { MANAGE_PARTNER_ADMIN_VIEW, SUBMIT_PARTNER_ADMIN_FORM } from "../../analytics/Events";
import TEST_ID from "../../constants/TestIds";
import PartnerAdminSecurity from "./PartnerAdminSecurity";
import SupportBaseUrlInput from "./SupportBaseUrlInput";

const PartnerAdminForm = ({
  supportBaseUrl,
  hasSolutionPartnerBenefit,
  isSecurityApproved,
  issueKey,
  securityExpiryDate,
  canImportLicenses,
  onSubmit
}) => {
  const fireAnalyticsEvent = useAnalyticsEvents();

  const trackFormSubmission = () => fireAnalyticsEvent({
    eventType: ButtonClickedEvent,
    eventContainer: MANAGE_PARTNER_ADMIN_VIEW,
    actionSubjectId: SUBMIT_PARTNER_ADMIN_FORM
  });

  return /*#__PURE__*/React.createElement(Form, {
    onSubmit: data => onSubmit({ ...data,
      initialSecurityIssueKey: issueKey,
      initialSupportBaseUrl: supportBaseUrl
    })
  }, ({
    formProps,
    submitting
  }) => /*#__PURE__*/React.createElement("form", _extends({}, formProps, {
    name: "partner-admin-form"
  }), /*#__PURE__*/React.createElement(SupportBaseUrlInput, {
    baseUrl: supportBaseUrl
  }), /*#__PURE__*/React.createElement(CheckboxField, {
    name: "hasSolutionPartnerBenefit",
    defaultIsChecked: hasSolutionPartnerBenefit
  }, ({
    fieldProps
  }) => /*#__PURE__*/React.createElement(Checkbox, _extends({}, fieldProps, {
    label: "The partner received the free licensing benefit from the Solution Partner program",
    size: "xlarge"
  }))), /*#__PURE__*/React.createElement(FormSection, {
    title: "Grant access"
  }, /*#__PURE__*/React.createElement(CheckboxField, {
    name: "canImportLicenses",
    defaultIsChecked: canImportLicenses
  }, ({
    fieldProps
  }) => /*#__PURE__*/React.createElement(Checkbox, _extends({}, fieldProps, {
    label: "The partner may use the license import API",
    size: "xlarge"
  })))), /*#__PURE__*/React.createElement(PartnerAdminSecurity, {
    isApproved: isSecurityApproved,
    issueKey: issueKey,
    expiryDate: securityExpiryDate
  }), /*#__PURE__*/React.createElement(FormFooter, null, /*#__PURE__*/React.createElement(Button, {
    testId: TEST_ID.ADMIN_TAB_SAVE_FORM_BUTTON,
    type: "submit",
    appearance: "primary",
    isLoading: submitting,
    onClick: trackFormSubmission
  }, "Save"))));
};

export default PartnerAdminForm;